var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"disabled":_vm.disabled,"color":"primary"},on:{"click":_vm.exportToExcel}},[_vm._v("Exportar para Excel")])}
var staticRenderFns = []

export { render, staticRenderFns }